module.exports = __webpack_public_path__ + "05_medium_black.5c154f1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/05_medium_black.png
// module id = Hz5F
// module chunks = 0